import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
  *, 
  *::after, 
  *::before {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    list-style:none;
  }
  
  body {
    font-family: "Roboto", -apple-system, BlinkMacSystemFont, "Segoe UI", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans",
    "Droid Sans", "Helvetica Neue", sans-serif;
    height: 100vh;
    text-rendering: optimizeLegibility;
  }
 
  @media (min-width: ${p => p.theme.breakpoints.sm}) {
    *{
      scrollbar-width: thin;
      scrollbar-color:${p => `${p.theme.colors.grey[500]} ${p.theme.colors.background.paper}`};
      &::-webkit-scrollbar {
        width: 10px;
        height: 10px;
      }
      &::-webkit-scrollbar-track {
        background: ${p => p.theme.colors.background.paper};
      }
      &::-webkit-scrollbar-thumb {
        background-color: ${p => p.theme.colors.grey[500]};
        border-radius: 5px;
      }
    }
  }
`;
